export const GRID_VIEW = 'grid';
export const TABLE_VIEW = 'table';

export const FILES_VIEWS = [
  { type: GRID_VIEW, title: 'Grid' },
  { type: TABLE_VIEW, title: 'List' },
];

export const getEnabledFilesViews = (views) => {
  const enabledViews = FILES_VIEWS.map((view) => view.type).filter(
    (type) => Array.isArray(views) && views.includes(type)
  );

  return enabledViews.length > 0 ? enabledViews : FILES_VIEWS.map((view) => view.type);
};

export const getDefaultFilesView = (views, defaultView) => {
  const enabledViews = getEnabledFilesViews(views);

  return enabledViews.includes(defaultView) ? defaultView : enabledViews[0];
};
